module.exports = __webpack_public_path__ + "static/media/icon_datetime.1ec11089.png";